import api from '@/utils/api'

export default {
    createSportClass(data) {
        return api.post(`sport-classes`, data)
    },
    getSportClass(sportClassId) {
        return api.get(`sport-classes/${sportClassId}`)
    },
    getSportClasses(params) {
        return api.get(`sport-classes`, { params })
    },
    updateSportClass(sportClassId, data) {
        return api.put(`sport-classes/${sportClassId}`, data)
    },
    getFilteredSportClasses(filters, page, size) {
        const params = { ...filters, page, size }
        return api.get(`sport-classes`, { params })
    },
    userAttendance(sportClassId, userId) {
        return api.post(`sport-classes/${sportClassId}/user/${userId}/attendance`, {})
    },
    coachAttendance(sportClassId, coachId) {
        return api.post(`sport-classes/${sportClassId}/coach/${coachId}/attendance`, {})
    }
}
